/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A link action.
 */
export type LinkAction = {
  /**
   * The domain we will link to.
   */
  domain?: string | undefined;
  /**
   * The id of the link.
   */
  id: string;
};

/** @internal */
export const LinkAction$inboundSchema: z.ZodType<
  LinkAction,
  z.ZodTypeDef,
  unknown
> = z.object({
  domain: types.optional(types.string()),
  id: types.string(),
});
/** @internal */
export type LinkAction$Outbound = {
  domain?: string | undefined;
  id: string;
};

/** @internal */
export const LinkAction$outboundSchema: z.ZodType<
  LinkAction$Outbound,
  z.ZodTypeDef,
  LinkAction
> = z.object({
  domain: z.string().optional(),
  id: z.string(),
});

export function linkActionToJSON(linkAction: LinkAction): string {
  return JSON.stringify(LinkAction$outboundSchema.parse(linkAction));
}
export function linkActionFromJSON(
  jsonString: string,
): SafeParseResult<LinkAction, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LinkAction$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinkAction' from JSON`,
  );
}
